export default __webpack_public_path__ + "static/media/tuto_kingdom_3_2x.12bebd6c.webp";